import {ChangeDetectionStrategy, Component} from "@angular/core"
import {BaseInspectorComponent} from "@template-editor/components/inspectors/base-inspector/base-inspector.component"
import {InspectorSectionComponent} from "@template-editor/components/inspectors/inspector-section/inspector-section.component"
import {ValueSlotComponent} from "@template-editor/components/value-slot/value-slot.component"
import type {MattressMesh} from "@cm/mattress-nodes"

@Component({
    selector: "cm-mattress-mesh-inspector",
    templateUrl: "./mattress-mesh-inspector.component.html",
    styleUrl: "./mattress-mesh-inspector.component.scss",
    imports: [InspectorSectionComponent, ValueSlotComponent],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MattressMeshInspectorComponent extends BaseInspectorComponent<MattressMesh> {}
